<template>
  <q-btn
    v-bind="$attrs"
    flat
    :class="['text-button', { 'text-button--underline': underline }]"
    :ripple="false"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>

    <div v-if="label" class="text-button__content">
      <span>{{ label }}</span>
    </div>

    <c-tooltip v-if="tooltip.length">{{ tooltip }}</c-tooltip>
  </q-btn>
</template>

<script setup>
const props = defineProps({
  // Only use SM for size. Where is the default is MD.
  size: {
    type: String,
    default: "md",
    validator: (value) => {
      return ["sm", "md"].includes(value);
    },
  },
  tooltip: {
    type: String,
    default: "",
  },
  label: {
    type: [String, null],
    default: null,
  },
  underline: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
button.q-btn.text-button {
  @apply tw-flex tw-min-h-0 tw-max-w-full tw-items-center tw-gap-2 tw-overflow-hidden tw-p-0 tw-font-medium tw-text-gray-800 tw-no-underline;

  &:hover::before {
    @apply tw-bg-transparent;
  }

  .q-btn__content {
    @apply tw-flex tw-flex-nowrap tw-items-center tw-gap-2 tw-font-normal;

    .text-button__content {
      > span {
        @apply tw-line-clamp-1 tw-text-left;
      }
    }
  }

  &.text-button--underline .q-btn__content .text-button__content > span {
    @apply tw-underline;
  }
}
</style>
